<app-header></app-header>

<app-sidebar
  class="sidebar position-fixed left-0"
  [navigation]="navigation"
></app-sidebar>

<main class="router-content">
  <router-outlet></router-outlet>
</main>
